export interface CacheEntry {
  sha256: string;
  size: number;
  bytesWritten: number;
  state: 'partial' | 'complete';
  filename: string;
  gameIds: string[];
  pinned: boolean;
  lastUsedAt: number;
  createdAt: number;
  verifiedAt: number | null;
}

export type CacheErrorKind = 'quota' | 'integrity' | 'aborted' | 'network' | 'permanent' | 'unsupported';

export class CacheError extends Error {
  constructor(public readonly kind: CacheErrorKind, message: string = kind, options?: ErrorOptions) {
    super(message, options);
    this.name = 'CacheError';
  }
}

export interface DownloadParams {
  sha256: string;
  size: number;
  filename: string;
  gameId: string;
  getUrl: () => Promise<string>;
  signal?: AbortSignal;
  onProgress?: (progress: { loaded: number; total: number; speedBps: number }) => void;
  fetchImpl?: typeof fetch;
}

/** All offsets and lengths are bytes. Implementations only own game-file storage. */
export interface BlobStore {
  write(sha256: string, offset: number, data: Uint8Array): Promise<void>;
  truncate(sha256: string, size: number): Promise<void>;
  read(sha256: string): Promise<Blob>;
  stream(sha256: string): AsyncIterable<Uint8Array>;
  remove(sha256: string): Promise<void>;
}
